import React from 'react';
import { Container, Dropdown, Navbar } from 'react-bootstrap';
import { CgProfile } from "react-icons/cg";
import { LinkContainer } from 'react-router-bootstrap';
import Logout from '../../features/auth/components/Logout';
import './DashboardPage.scss';

interface DashboardPageProps {
    heading: string;
    children: React.ReactNode
}

const DashboardPage = (props: DashboardPageProps) => {
    return (
        <>
            <Navbar bg="white" sticky="top">
                <Container fluid className="px-5 mb-0 py-2" >
                    <h4 className="mb-1"><strong>{props.heading}</strong></h4>
                    <Dropdown drop="start" className="d-grid d-lg-none">
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            className="d-flex justify-content-between align-items-center">
                            <CgProfile />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-menu text-small shadow">
                            <LinkContainer to="/profile">
                                <Dropdown.Item className="dropdown-item">Profile</Dropdown.Item>
                            </LinkContainer>
                            <Dropdown.Divider />
                            <Dropdown.Item className="dropdown-item" ><Logout /></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Container>
            </Navbar>
            <Container fluid className="py-4 px-5">
                {props.children}
            </Container>

        </>
    )
}

export default DashboardPage